import SolusiMekanikLogo from "src/assets/images/solusi_mekanik_logo.png";

export const appAsset = {
  appName: "Solusi Mekanik",
  appLogo1: SolusiMekanikLogo,
  appLogo2: undefined as any,
  appTabIconHref: "/faviconSolusiMekanik.ico",
  appleTouchIconLinkHref: "/logo192SolusiMekanik.png",
  bankName: "CV Solusi Jaya Bersama",
  bankAccount: "BCA 5551 011 888",
  contact: {
    isEmail: true,
    value: ["sales@solusimekanik.com"],
    phone: "+62 822 2962 7809",
  },
};